<template>
  <b-dropdown
    no-caret
    variant="link"
    toggle-class="p-1 text-muted item-actions-toggle"
    menu-class="item-actions-dropdown-menu"
    boundary="window"
    :popper-opts="{ positionFixed: true }"
    right
    @click.native.stop
    @show="$emit('open')"
    @hide="$emit('close')"
  >
    <template #button-content>
      <MoreHorizontalIcon
        :width="16"
        :height="16"
      />
    </template>
    <b-dropdown-item @click.stop="editItem">
      <PencilIcon
        :width="14"
        :height="14"
        class="mr-2"
      />
      Rename
    </b-dropdown-item>
    <b-dropdown-item
      v-if="canCustomize"
      @click.stop="customizeItem"
    >
      <PaletteIcon
        :width="14"
        :height="14"
        class="mr-2"
      />
      Customize...
    </b-dropdown-item>
    <b-dropdown-divider v-if="canCustomize" />
    <b-dropdown-item
      link-class="text-danger"
      @click.stop="deleteItem"
    >
      <Trash2Icon
        :width="14"
        :height="14"
        class="mr-2"
      />
      Delete
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { MUTATIONS } from '../../../../../store/file-browser'
import { createModal } from '../../modals/action-creater'
import { MODALS, TABS } from '../../constants'
import { FILE_TYPE } from '@frontend/constants/file-image-types'
import {
  MoreHorizontal as MoreHorizontalIcon,
  Pencil as PencilIcon,
  Palette as PaletteIcon,
  Trash2 as Trash2Icon,
} from 'lucide-vue'

const { mapMutations } = createNamespacedHelpers('fileBrowser')

export default {
  name: 'ItemActionsDropdown',
  components: {
    MoreHorizontalIcon,
    PencilIcon,
    PaletteIcon,
    Trash2Icon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFolder() {
      return this.item?.type === FILE_TYPE.FOLDER || this.item?.type === 'folder'
    },
    canCustomize() {
      const tab = this.$route?.params?.tab
      return this.isFolder && [TABS.FILES, TABS.PRODUCTS].includes(tab)
    },
    currentTab() {
      // Off-route embeddings (e.g. Run Reports' "Import From" file picker) have no
      // `:tab` route param, so fall back to the file-upload-images store tab, which
      // is what actually drives Files/Products content in that context (see
      // SelectFolderModalContentView.vue's `isFilesTab`/`availableOverlay`).
      return this.$route?.params?.tab || this.$store.getters['fileUploadImages/getTab']
    },
  },
  methods: {
    ...mapMutations({
      setModal: MUTATIONS.SET_MODAL,
    }),
    deleteItem() {
      this.setModal(createModal(MODALS.DELETE_ITEM, this.item))
    },
    customizeItem() {
      this.setModal(createModal(MODALS.CUSTOMIZE_FOLDER, this.item))
    },
    editItem() {
      let modal = MODALS.TAGS_EDITOR

      switch (this.currentTab) {
        case TABS.FILES:
        case TABS.PRODUCTS:
          modal = MODALS.RENAME
          break
      }

      this.setModal(createModal(modal, {
        ...this.item,
        needValidation: this.currentTab === TABS.PRODUCTS && this.item.type === 'image',
      }))
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .item-actions-toggle {
  line-height: 1;
  color: #6b7280;

  &:hover {
    color: #111827;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
}

::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

::v-deep .item-actions-dropdown-menu {
  z-index: 1080 !important;
}
</style>
